export default {
  namespaced: true,
  state: {
    isShowAutoRefresh: false,
    WPMDashboardAutoRefresh: true,
    WPMExecutiveDashboardAutoRefresh: true,
    WPMSiteAccessDashboardAutoRefresh: true,
    SMSDashboardAutoRefresh: true,
    BMMDashboardAutoRefresh: true,
    NCMDashboardAutoRefresh: true,
  },
  getters: {
    getIsShowAutoRefresh(state) {
      return state.isShowAutoRefresh
    },

    getWPMDashboardAutoRefresh(state) {
      return state.WPMDashboardAutoRefresh
    },

    getWPMExecutiveDashboardAutoRefresh(state) {
      return state.WPMExecutiveDashboardAutoRefresh
    },

    getWPMSiteAccessDashboardAutoRefresh(state) {
      return state.WPMSiteAccessDashboardAutoRefresh
    },

    getSMSDashboardAutoRefresh(state) {
      return state.SMSDashboardAutoRefresh
    },

    getBMMDashboardAutoRefresh(state) {
      return state.BMMDashboardAutoRefresh
    },

    getNCMDashboardAutoRefresh(state) {
      return state.NCMDashboardAutoRefresh
    },
  },
  mutations: {
    SET_IS_SHOW_AUTO_REFRESH(state, value) {
      state.isShowAutoRefresh = value
    },

    SET_WPM_DASHBOARD_AUTO_REFRESH(state, value) {
      state.WPMDashboardAutoRefresh = value
    },

    SET_WPM_EXECUTIVE_DASHBOARD_AUTO_REFRESH(state, value) {
      state.WPMExecutiveDashboardAutoRefresh = value
    },

    SET_WPM_SITE_ACCESS_DASHBOARD_AUTO_REFRESH(state, value) {
      state.WPMSiteAccessDashboardAutoRefresh = value
    },

    SET_SMS_DASHBOARD_AUTO_REFRESH(state, value) {
      state.SMSDashboardAutoRefresh = value
    },

    SET_BMM_DASHBOARD_AUTO_REFRESH(state, value) {
      state.SMSDashboardAutoRefresh = value
    },

    SET_NCM_DASHBOARD_AUTO_REFRESH(state, value) {
      state.SMSDashboardAutoRefresh = value
    },
  },
  actions: {
    setIsShowAutoRefresh({ commit }, value) {
      commit("SET_IS_SHOW_AUTO_REFRESH", value)
    },

    setWPMDashboardAutoRefresh({ commit }, value) {
      commit("SET_WPM_DASHBOARD_AUTO_REFRESH", value)
      localStorage.setItem("wpm-dashboard-auto-refresh", value)
    },

    setWPMExecutiveDashboardAutoRefresh({ commit }, value) {
      commit("SET_WPM_EXECUTIVE_DASHBOARD_AUTO_REFRESH", value)
      localStorage.setItem("wpm-executive-dashboard-auto-refresh", value)
    },

    setWPMSiteAccessDashboardAutoRefresh({ commit }, value) {
      commit("SET_WPM_SITE_ACCESS_DASHBOARD_AUTO_REFRESH", value)
      localStorage.setItem("wpm-site-access-dashboard-auto-refresh", value)
    },

    setSMSDashboardAutoRefresh({ commit }, value) {
      commit("SET_SMS_DASHBOARD_AUTO_REFRESH", value)
      localStorage.setItem("sms-dashboard-auto-refresh", value)
    },

    setBMMDashboardAutoRefresh({ commit }, value) {
      commit("SET_BMM_DASHBOARD_AUTO_REFRESH", value)
      localStorage.setItem("bmm-dashboard-auto-refresh", value)
    },

    setNCMDashboardAutoRefresh({ commit }, value) {
      commit("SET_NCM_DASHBOARD_AUTO_REFRESH", value)
      localStorage.setItem("ncm-dashboard-auto-refresh", value)
    },
  },
}
